<template>
  <div>
    <vue-progress-bar></vue-progress-bar>
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
  export default {
    name: 'duels-wrapper',
  };
</script>

<style scoped>

</style>
